import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  IconButton,
  TableHead,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGetAllChaptersPaginationMutation } from "../app/services/chapterServices";
import ReactPaginate from "react-paginate";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

//Table header
function EnhancedTableHead() {
  const headCells = [
    { id: "title", width: '25%', numeric: false, disablePadding: true, label: "Title" },
    {
      id: "logo",
      numeric: true,
      disablePadding: false,
      label: "Logo",
    },
    { id: "state", numeric: false, disablePadding: true, label: "State" },
    {
      id: "establishedOn",
      numeric: true,
      disablePadding: false,
      label: "Established On",
    },
    { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff", width: headCell?.width ? headCell?.width : 'auto' }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

function ChapterPendingTable() {
  const [allChapters, setAllChapters] = useState([]);
  const [getAllChapterPagination] = useGetAllChaptersPaginationMutation();
  const [page, setPage] = useState(0);
  // const itemsPerPage = 10;
  const [totalPage, setTotalPage] = useState(0);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const pageCount = Math.ceil(totalPage / itemsPerPage);

  const navigate = useNavigate()

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };
  const handlePageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };
  useEffect(() => {
    const data = {
      page: page + 1,
      itemsPerPage: itemsPerPage,
      approve: 0,
      searchTerm: ''
    };
    getAllChapterPagination(data).then((res) => {
      if (res?.data?.status) {
        setAllChapters(res?.data?.data?.chapterData);
        setTotalPage(res?.data?.data?.totalCount);
      }
    });
  }, [getAllChapterPagination, page, itemsPerPage]);

  return (
    <>
      <Box className="mt-5">
        <TableContainer
          component={Paper}
          sx={{ boxShadow: 0 }}
          className="rounded-0"
        >
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <EnhancedTableHead />
            <TableBody>
              {allChapters?.length > 0 ? (
                allChapters.map((chapter, index) => (
                  <TableRow
                    hover
                    key={chapter._id}
                    sx={{
                      cursor: "pointer",
                      backgroundColor: index % 2 === 0 ? "#f0f0f0" : "white",
                    }}
                  >
                    <TableCell align="center">{chapter?.title}</TableCell>
                    <TableCell align="center">
                      <img
                        src={
                          chapter.imageUrl
                            ? `${chapter.imageUrl}?t=${new Date().getTime()}`
                            : "/assets/images/login/userLogo.png"
                        }
                        className="rounded-circle"
                        width={"40px"}
                        height={"40px"}
                        alt="View chapter"
                      />
                    </TableCell>
                    <TableCell align="center">{chapter?.state}</TableCell>
                    <TableCell align="center">
                      {new Date(chapter.establishedOn).toLocaleDateString(
                        "en-In",
                        {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        }
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        verticalAlign: "middle", // Align content to the middle of the cell
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap="8px"
                        flexWrap="wrap"
                      >
                        <Tooltip title="View" placement="top">
                          <IconButton
                            aria-label="ViewIcon"
                            onClick={() => {
                              navigate("/admin/view-pending-Chapter/" + chapter.chapterUrl)
                            }}
                          >
                            <VisibilityIcon className="icon-vieweye-color" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    Will Be Added Shortly
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <br />
        {allChapters?.length > 0 && (
          // <ReactPaginate
          //   pageCount={pageCount} // Calculate total pages
          //   pageRangeDisplayed={2}
          //   marginPagesDisplayed={1}
          //   onPageChange={handlechapterPageClick}
          //   containerClassName={"pagination"}
          //   activeClassName={"active"}
          //   forcePage={page}
          //   previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
          //   nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
          //   disabledClassName={"disablebtn"}
          // />
          <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
            <div className="mb-2 mb-md-0">
              <div className="d-flex gap-2">
                <input
                  type="number"
                  min={1}
                  placeholder="Page no."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
                <div className="goPage cursor-pointer" onClick={handlePageChange}>
                  <h5 className="p-2 m-0">Go</h5>
                </div>
              </div>
              {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
            </div>

            {/* Pagination in the Center */}
            <div className="my-3 my-md-0">
              <ReactPaginate
                pageCount={pageCount} // Calculate total pages
                pageRangeDisplayed={1}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={page}
                previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                nextLabel={
                  pageCount > 1 && page + 1 !== pageCount ? "Next" : null
                }
                disabledClassName={"disablebtn"}
              />
            </div>
            <div className="mb-2 mb-md-0">
              <FormControl variant="outlined">
                <InputLabel></InputLabel>
                <Select
                  className="itemsperpage"
                  value={itemsPerPage}
                  onChange={(e) => {
                    const value = e.target.value;
                    setItemsPerPage(value);
                    setError('');
                    setSearchTerm('');
                    setPage(0);
                  }}
                  MenuProps={{
                    MenuListProps: {
                      sx: {
                        display: 'flex',
                        flexDirection: 'column',
                      },
                    },
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>

              </FormControl>
            </div>
          </div>
        )}
      </Box>
    </>
  );
}

export default ChapterPendingTable;
